import type { Performer } from "@shared/schema";

export type ParticipantMode = 'jam-night' | 'open-mic' | 'generic-event';

export interface ModeConfig {
  isJamNight: boolean;
  isOpenMic: boolean;
  isGenericEvent: boolean;
  title: string;
  defaultFilters: {
    played?: string;
    attended?: "all" | "attended" | "not-attended";
  };
  shouldFilterPerformers: (performer: Performer) => boolean;
  columns: string[];
  hasInstrumentFilter: boolean;
  hasTypeFilter: boolean;
}

export function getModeConfig(mode: ParticipantMode, performers: Performer[]): ModeConfig {
  const isJamNight = mode === 'jam-night';
  const isOpenMic = mode === 'open-mic';
  const isGenericEvent = mode === 'generic-event';

  const shouldFilterPerformers = (performer: Performer): boolean => {
    if (performer.removed) return false;
    
    if (isJamNight) {
      return performer.status === 'participant' || performer.status === 'consideration';
    } else if (isOpenMic) {
      return performer.status !== 'on_stage';
    } else {
      return true;
    }
  };

  const getColumns = (): string[] => {
    const columns = ["Name"];
    
    if (isJamNight) {
      columns.push("Instruments", "Tier");
    } else if (isOpenMic) {
      columns.push("Type");
    }
    
    columns.push("Priority");
    columns.push(isGenericEvent ? "Attended" : "Played");
    
    if (isJamNight) {
      columns.push("Times Performed");
    }
    
    if (!isGenericEvent) {
      columns.push("Time on Stage");
    }
    
    columns.push("Actions");
    return columns;
  };

  return {
    isJamNight,
    isOpenMic,
    isGenericEvent,
    title: isOpenMic ? "Open Mic Participants" : "Participants",
    defaultFilters: {
      played: isOpenMic ? "not-played" : "all",
      attended: isGenericEvent ? "not-attended" : "all",
    },
    shouldFilterPerformers,
    columns: getColumns(),
    hasInstrumentFilter: isJamNight,
    hasTypeFilter: isOpenMic,
  };
}